export class ActionClick {
    constructor({el, wrapEffect}) {
        this.DOM = {el, wrapEffect};
        this.DOM.el.classList.add('parentActionClick');
    }

    mouseDown() {
        const span = document.createElement('span');
        span.classList.add('actionClick');
        if (this.DOM.wrapEffect) {
            this.DOM.wrapEffect.append(span);
        } else {
            this.DOM.el.append(span);
        }
        setTimeout(() => {
            span.remove();
        }, 550);
    }
}
